module.exports = __webpack_public_path__ + "img/main-slots.e26ccd07.png";